// ======================================================================
// File Name       : unsubmitted
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================
import * as actionTypes from '../../../constants/actionTypes/report';

export function receiveUnsubmittedReportSearch(reportListResult) {
  return {
    type: actionTypes.UNSUBMITTED_REPORT_SEARCH,
    reportListResult,
  };
}

export function receiveUserList(userList) {
  return {
    type: actionTypes.UNSUBMITTED_REPORT_USER_LIST_SEARCH,
    userList,
  };
}

export function receiveGroupList(result) {
  return {
    type: actionTypes.UNSUBMITTED_REPORT_GROUP_LIST,
    groupList: result.groupList,
  };
}

export function receiveReportResetInit() {
  return {
    type: actionTypes.UNSUBMITTED_REPORT_RESET_INIT,
  };
}

export function receiveUpdateSearchInfo(searchInfo) {
  return {
    type: actionTypes.UNSUBMITTED_REPORT_UPDATE_SEARCH_INFO,
    searchInfo,
  };
}
